var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrencyEuro = function SvgCurrencyEuro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2024",
    fillRule: "evenodd",
    d: "M3.539 6.417a4.4 4.4 0 0 0 0 1.166h4.044a.583.583 0 0 1 0 1.167H3.864a4.376 4.376 0 0 0 6.842 1.586.583.583 0 1 1 .755.89A5.544 5.544 0 0 1 2.615 8.75H1.75a.583.583 0 1 1 0-1.168h.614a5.6 5.6 0 0 1 0-1.166H1.75a.583.583 0 1 1 0-1.167h.865a5.544 5.544 0 0 1 8.846-2.475.583.583 0 0 1-.755.889A4.376 4.376 0 0 0 3.864 5.25h3.72a.583.583 0 0 1 0 1.167z",
    clipRule: "evenodd"
  })));
};
export default SvgCurrencyEuro;